import { useEffect } from "react";
import { useNavigate } from "react-router";
import { PageHeader } from "@/components/page-header";
import { useMe } from "@/lib/hooks/use-clients";
import { useT } from "@/lib/i18n/use-t";
import { hasPermission, type Permission } from "@/lib/permissions";
import { BatchLookupWrapper } from "./batch-lookup-wrapper";
import { T } from "./page.i18n";

export default function BatchLookupPage() {
  const t = useT(T);
  const navigate = useNavigate();
  const { me, isLoading } = useMe();
  const userPermissions = (me?.permissions || ["advisor"]) as Permission[];

  useEffect(() => {
    if (!isLoading && !hasPermission(userPermissions, "compliance")) {
      navigate("/", { replace: true });
    }
  }, [isLoading, userPermissions, navigate]);

  if (isLoading || !hasPermission(userPermissions, "compliance")) return null;

  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumbs={[{ label: t.compliance, href: "/compliance" }, { label: t.breadcrumb }]}
        title={t.title}
        description={t.description}
      />

      <BatchLookupWrapper />
    </div>
  );
}
